'use client';

import Link from '@components/Link';
import { ArrowLeftIcon } from '@ngg/icons';
import { useRouter } from 'next/navigation';
import type { Dictionary } from 'types';

import { cn } from '@/lib/utils';

import { useBreadcrumbsPath } from './Breadcrumb.hooks';

type BreadcrumbsPreviousLinkProps = {
    className?: string;
    href: string;
    locale?: string;
    dictionary?: Dictionary;
    isProductPage?: boolean;
};

export default function BreadcrumbsPreviousLink({
    className,
    href,
    locale,
    dictionary,
    isProductPage,
}: BreadcrumbsPreviousLinkProps) {
    const router = useRouter();
    const { hasPreviousPath } = useBreadcrumbsPath();

    if (isProductPage && hasPreviousPath) {
        return (
            <button
                className="inline-flex content-center items-center gap-0.5 border border-grey-150 bg-white px-1.5 py-1 text-black transition-colors duration-150 hover:border-black hover:text-black"
                onClick={() => {
                    router.back();
                }}>
                <ArrowLeftIcon
                    className={cn(
                        'max-lg:text-black',
                        dictionary?.back ? 'h-4 w-4' : 'h-5 w-5',
                    )}
                />
                {dictionary?.back}
            </button>
        );
    }

    return (
        <Link
            href={href}
            locale={locale}
            prefetch={false}
            className={cn(
                'inline-flex content-center items-center gap-0.5 transition-colors duration-150 hover:text-black',
                dictionary?.back
                    ? 'border border-grey-150 bg-white px-1.5 py-1 text-black hover:border-black'
                    : 'lg:hidden',
                className,
            )}>
            <ArrowLeftIcon
                className={cn(
                    'max-lg:text-black',
                    dictionary?.back ? 'h-4 w-4' : 'h-5 w-5',
                )}
            />
            {dictionary?.back}
        </Link>
    );
}
